const { routerPreFix } = require('$proDirname/prefix');
const commomImport = filePath => resolve => import(`$merChantViews/${filePath}`).then(resolve);
//  设置 spa 的路由前缀
const prefix =
  window?.Vue?.prototype?.ssr?.config?.routerConfig?.name ??
  `/${routerPreFix.merchant}/index`;
import Layout from '$merchantComponent/layout/home'
import Nprogress from "nprogress";

const routes = [
  {
    path: '/',
    hidden: true,
    redirect: `/order-manager/pre-order`
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [{
      path: '/redirect/:path(.*)',
      component: () => import('$merchantComponent/layout/sider-bar/redirect')
    }]
  },
  {
    path: '/403',
    component: () => import('$merchantComponent/error/403'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('$merchantComponent/error/404'),
    hidden: true
  }
]
const pageRouterInfo = require.context('./', true, /index*\.js$/);
pageRouterInfo.keys().forEach(key => routes.push(pageRouterInfo(key).default?.call(this, commomImport)[0]))
routes.filter(Boolean)
export default {
  use: (Vue, Router) => {
    Vue.use(Router);

    const router = new Router({
      mode: 'history',
      base: prefix,
      routes,
      scrollBehavior(to, from, savedPosition) {
        return {
          x: 0,
          y: 0
        };
      }
    });
    // //  路由切换懒加载对应的国家化文案
    router.beforeEach((to, from, next) => {
      Nprogress.start()
      if (window.$vm?.$root?.backRouterName && to.name !== window.$vm?.$root?.backRouterName) {
        this.$router.go(-1);
      } else {
        if (window.$vm?.$root) {
          window.$vm.$root.backRouterName = '';
        }
        next();
      }
    });
    router.afterEach(() => {
      Nprogress.done()
    })
    return router;
  }
};
